import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {IPlatformHomeMagicBar} from "@shared/components/platform-tool/platform-tool-magic-bar/models/magic-bar-models";
import {HomeSideBarItem} from "@shared/models/platform-tool-models";
import {FlexSheetService} from "@features/spreadsheet/services/flex-sheet.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {SpreadSheetEvent, WorksheetModel} from "@features/spreadsheet/models/spread-sheet";
import {PlatformQuery} from "@shared/models/platform-query/platform-query";
import {Api} from "@shared/constants/common-field.constants";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {EliteFormFlowChartDataService} from "@features/elite-form/services/elite-form-flow-chart-data.service";

@Component({
  selector: 'app-user-guide-validation-errors',
  standalone: false,
  templateUrl: './user-guide-validation-errors.component.html',
  styleUrl: './user-guide-validation-errors.component.scss'
})
export class UserGuideValidationErrorsComponent implements IPlatformHomeMagicBar, OnInit, OnDestroy, AfterViewInit {
  homeSideBarItem: HomeSideBarItem;
  title = 'Hello';
  ruleId: string;
  ruleDescription: string;
  private unSubscribe$ = new Subject<void>();
  private currentWorksheet: WorksheetModel;
  private currentWorksheetName: string;
  userGuideRules: any[] = [];
  currentRule: any;
  displayedColumns: string[] = ['rule', 'description'];

  @ViewChildren('ruleRow') private ruleRows: QueryList<ElementRef<HTMLTableRowElement>>;
  @ViewChild('gridContainer') private gridContainer: ElementRef<HTMLDivElement>;

  constructor(private flexSheetService: FlexSheetService,
              private eliteFormFlowChartDataService: EliteFormFlowChartDataService,
              private platformQueryService: PlatformQueryService) {
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  ngOnInit(): void {
    this.fetchUserGuideValidationErrors();
    this.currentWorksheet = this.flexSheetService.getCurrentWorkSheet();
    this.flexSheetService.spreadSheetEvent$.pipe(takeUntil(this.unSubscribe$)).subscribe((event: any) => {
      if (event.name === SpreadSheetEvent.WorkSheetChanged) {
        this.currentWorksheet = event.payload;
      }
    });
    this.flexSheetService.spreadSheetEvent$.pipe(takeUntil(this.unSubscribe$)).subscribe((event: any) => {
      if (event.name === SpreadSheetEvent.CellSelected) {
        const payload = event.payload;
        if (!this.userGuideRules || !this.currentWorksheet) {
          return;
        }
        const currentWorksheetRules = this.userGuideRules.filter(o => o.worksheetName === this.currentWorksheet.name);
        this.currentRule = currentWorksheetRules.find(o => Number(o.cellRow) === payload.r && Number(o.cellColumn - 1) === payload.c);
        this.scrollToCurrentRule();
      }
    });
  }

  ngAfterViewInit(): void {
    this.ruleRows?.changes.pipe(takeUntil(this.unSubscribe$)).subscribe(() => this.scrollToCurrentRule());
  }

  trackByRule = (_: number, rule: any): any => rule;

  private scrollToCurrentRule(): void {
    if (!this.currentRule || !this.gridContainer) {
      return;
    }
    const index = this.userGuideRules.indexOf(this.currentRule);
    if (index < 0) {
      return;
    }
    requestAnimationFrame(() => {
      const container = this.gridContainer.nativeElement;
      const rows = container.querySelectorAll<HTMLElement>('tr[mat-row]');
      const rowEl = rows[index];
      if (!rowEl) {
        return;
      }
      const containerRect = container.getBoundingClientRect();
      const rowRect = rowEl.getBoundingClientRect();
      const relativeTop = rowRect.top - containerRect.top + container.scrollTop;
      const target = relativeTop - (container.clientHeight - rowEl.offsetHeight) / 2;
      const maxScroll = container.scrollHeight - container.clientHeight;
      container.scrollTo({top: Math.max(0, Math.min(target, maxScroll)), behavior: 'smooth'});
    });
  }

  private fetchUserGuideValidationErrors() {
    const query = new PlatformQuery();
    query.name = 'UserGuideValidationErrorsQuery';
    query.api = Api.FilingManagerApi;
    query.fieldValues['ResponseId'] = this.homeSideBarItem.fieldValues['ResponseId'];
    query.fieldValues['SchemaId'] = this.homeSideBarItem.fieldValues['SchemaId'];
    this.platformQueryService.executeQuery(query).subscribe(response => {
      if (response.fieldValues['CellValidationRuleModels']) {
        this.userGuideRules = response.fieldValues['CellValidationRuleModels'];
      }
    });
  }
}
